export const INFO_SEPARATOR = '|';
export const BREADCRUMB_SEPARATOR = '/';
export const EXTENSION_REGEX = /\.[a-zA-Z0-9]+$/;

export enum DragItemType {
  FILE = 'FILE',
  FOLDER = 'FOLDER',
}
